module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/android-icon-72x72-222d8bce32c722cb2157fd697091726f.png";